module.exports = __webpack_public_path__ + "media/images/vod_icons/rumble-4e92118c1c640c1334b2d3ff235cbe2f.svg";